const getHeaderTitle = (fullpath) => {
  const splitPath = fullpath.split('/').filter(path => path !== '')
  const splitPath1 = splitPath[splitPath.length - 1]
  let splitPath2 = splitPath[splitPath.length - 2]

  if (splitPath1 === 'detail' || splitPath1 === 'edit') {
    splitPath2 = splitPath[splitPath.length - 3]
  }
  if (fullpath.search('dashboard')>0) {
    return 'Dashboard'
  } else if (splitPath2.includes('company-data') && splitPath1.includes('create')) {
    return 'Tambah Perusahaan'
  } else if (splitPath2.includes('company-data') && splitPath1.includes('edit')) {
    return 'Data Perusahaan'
  } else if (splitPath2.includes('company-data') && splitPath1.includes('detail')) {
    return 'Detail Perusahaan'
  } else if (splitPath1.includes('company-data')) {
    return 'Data Perusahaan'
  } else if (splitPath2.includes('employee-data') && splitPath1.includes('bulk')) {
    return 'Tambah Data Karyawan'
  } else if (splitPath2.includes('bulk') && splitPath1.includes('detail')) {
    return 'Bulk Upload'
  } else if (splitPath2.includes('employee-data') && splitPath1.includes('create')) {
    return 'Tambah Karyawan'
  } else if (splitPath2.includes('employee-data') && splitPath1.includes('edit')) {
    return 'Ubah Data Karyawan'
  } else if (splitPath2.includes('employee-data') && splitPath1.includes('detail')) {
    return 'Detail Karyawan'
  } else if (splitPath2.includes('employee-data') && splitPath1.includes('pml-program')) {
    return 'Assign Program Manfaat Lainnya'
  } else if (splitPath2.includes('employee-data') && splitPath1.includes('existing-sync')) {
    return 'Sync Data Karyawan Existing'
  } else if (splitPath1.includes('employee-data')) {
    return 'Data Karyawan'
  } else if (splitPath2.includes('invoice') && splitPath1.includes('create')) {
    return 'Buat Invoice'
  } else if (splitPath2.includes('invoice') && splitPath1.includes('detail')) {
    return 'Detail Invoice'
  } else if (splitPath2.includes('invoice') && splitPath1.includes('adhoc')) {
    return 'Tambah Invoice Adhoc'
  } else if (splitPath1.includes('invoice')) {
    return 'Invoice'
  } else if (splitPath2.includes('claim') && splitPath1.includes('create')) {
    return 'Pengajuan Klaim'
  } else if (splitPath2.includes('claim') && splitPath1.includes('detail')) {
    return 'Detail Klaim'
  } else if (splitPath1.includes('claim')) {
    return 'Klaim'
  } else if (splitPath2.includes('payment-confirmation') && splitPath1.includes('detail')) {
    return 'Detail Pembayaran'
  } else if (splitPath1.includes('payment-confirmation')) {
    return 'Konfirmasi Pembayaran'
  } else if (splitPath1.includes('journal-contribution')) {
    return 'Jurnal Iuran'
  } else if (splitPath2.includes('payment-company') && splitPath1.includes('detail')) {
    return 'Detail Riwayat Pembayaran'
  } else if (splitPath1.includes('payment-company')) {
    return 'Riwayat Pembayaran'
  } else if (splitPath2.includes('company-subdivision') && splitPath1.includes('bulk')) {
    return 'Tambah Data Cabang'
  } else if (splitPath2.includes('company-subdivision') && splitPath1.includes('create')) {
    return 'Tambah Cabang'
  } else if (splitPath2.includes('company-subdivision') && splitPath1.includes('edit')) {
    return 'Edit Cabang'
  } else if (splitPath2.includes('company-subdivision') && splitPath1.includes('detail')) {
    return 'Detail Cabang'
  } else if (splitPath1.includes('company-subdivision')) {
    return 'Data Cabang'
  } else if (splitPath2.includes('updated') && splitPath1.includes('detail')) {
    return 'Detail Pengkinian Data'
  } else if (splitPath1.includes('updated')) {
    return 'Pengkinian Data'
  } else if (splitPath2.includes('user-company') && splitPath1.includes('edit')) {
    return 'Edit Hak Akses Karyawan'
  } else if (splitPath2.includes('user-company') && splitPath1.includes('detail')) {
    return 'Detail Hak Akses Karyawan'
  } else if (splitPath1.includes('user-company')) {
    return 'Hak Akses Karyawan'
  } else if (splitPath1.includes('type-of-investment')) {
    return 'Jenis Investasi'
  } else if (splitPath2.includes('role') && splitPath1.includes('create')) {
    return 'Tambah Hak Akses'
  } else if (splitPath2.includes('role') && splitPath1.includes('edit')) {
    return 'Edit Hak Akses'
  } else if (splitPath2.includes('role') && splitPath1.includes('detail')) {
    return 'Detail Hak Akses'
  } else if (splitPath1.includes('role')) {
    return 'Hak Akses'
  } else if (splitPath2.includes('user') && splitPath1.includes('create')) {
    return 'Tambah Akun Pengguna'
  } else if (splitPath2.includes('user') && splitPath1.includes('edit')) {
    return 'Edit Akun Pengguna'
  } else if (splitPath2.includes('user') && splitPath1.includes('detail')) {
    return 'Detail Akun Pengguna'
  } else if (splitPath1.includes('user')) {
    return 'Akun Pengguna'
  } else if (splitPath2.includes('reports') && splitPath1.includes('create')) {
    return 'Tambah Laporan'
  } else if (splitPath2.includes('reports') && splitPath1.includes('edit')) {
    return 'Edit Laporan'
  } else if (splitPath1.includes('reports')) {
    return 'Laporan'
  } else if (splitPath2.includes('forms') && splitPath1.includes('create')) {
    return 'Tambah Formulir'
  } else if (splitPath2.includes('forms') && splitPath1.includes('edit')) {
    return 'Edit Formulir'
  } else if (splitPath1.includes('forms')) {
    return 'Formulir'
  } else if (splitPath1.includes('notification-payment')) {
    return 'Notifikasi Pembayaran'
  } else if (splitPath2.includes('notification-payment') && splitPath1.includes('create')) {
    return 'Tambah Notifikasi Pembayaran'
  } else if(splitPath1.includes('log-notification-email')) {
    return 'Log Notifikasi Email'
  } else if(splitPath1.includes('email-broadcast')) {
    return 'Email Broadcast'
  } else if (splitPath2.includes('email-broadcast') && splitPath1.includes('create')) {
    return 'Tambah Email Broadcast'
  } else if (splitPath2.includes('email-broadcast') && splitPath1.includes('edit')) {
    return 'Ubah Email Broadcast'
  } else if (splitPath1.includes('configuration')) {
    return 'Konfigurasi'
  } else if (splitPath1.includes('log-sync')) {
    return 'Log Sinkronisasi'
  } else if (splitPath1.includes('core-sync-progress')) {
    return 'Progres Sinkronisasi Core'
  } else if (splitPath1.includes('core-mapping')) {
    return 'Mapping Core'
  } else if (splitPath1.includes('terms-condition')) {
    return 'Syarat & Ketentuan'
  } else if (splitPath1.includes('change-password')) {
    return 'Ganti Password'
  } else if (splitPath1.includes('log-activity')) {
    return 'Log Aktivitas'
  } else {
    return 'Dashboard'
  }
}

export default getHeaderTitle
